<template>
    <div :class="accordionClass">
        <div
            :class="headerClass"
            @click="isOpen = !isOpen"
        >
            {{ title }}
            <div :class="['icon-class', isOpen ? 'icon-open' : 'icon-closed']">
                <IconChevronDown tw-class="w-6 h-6 stroke-1 stroke-secondary"/>
            </div>
        </div>
        <transition name="slide-fade">
            <div
                v-if="isOpen"
                :class="contentClass"
            >
                <slot/>
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import IconChevronDown from '~/components/Icons/IconChevronDown.vue';

const {
    title = '',
    defaultOpen = false,
    accordionClass = 'bg-white shadow rounded-lg',
    headerClass = 'px-4 py-2 cursor-pointer',
    contentClass = 'p-2 gap-2',
} = defineProps<{
    title?: string,
    defaultOpen?: boolean,
    accordionClass?: string,
    headerClass?: string,
    contentClass?: string,
}>();

const isOpen = ref(defaultOpen);
</script>

<style scoped>
.icon-open {
    @apply transform rotate-180 transition-all duration-300;
}

.icon-closed {
    @apply transform rotate-0 transition-all duration-300;
}

/* Transition styles */
.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(10px);
    opacity: 0;
}
</style>
